import styled from "styled-components";

export const ContainerModalToken = styled.div`
  /* width: 100%; */
  height: 200px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  margin: 0 20px;
  span {
    /* width: 360px; */
    font-weight: 400;
    line-height: 150%;
    color: var(--color-latex10);
    font-size: 18px;
  }
  .btn {
    padding: 12px 26px;
    font-size: 18px;
    background-color: var(--color-broccoli);
    color: var(--color-white);
  }
  @media (max-width: 768px) {
    width: 300px;
  }
`;
